module.exports = __webpack_public_path__ + "static/media/tj.a99bd1a8.svg";